<template>
  <div class="b-notification-block">
    <div
      v-if="messages.length > 0"
      class="b-notification b-notification__warning"
    >
      <div class="b-notification__icon-wrap p-4">
        <dynamic-icon icon="warning" />
      </div>
      <div class="b-notification__text-wrap px-4">
        <div class="b-notification__title">
          {{ $t('CONTENT.reportPage.no_discounting_directory_entries_months_indicated_below') }}
        </div>
        <button
          class="b-btn b-btn_type_empty px-0"
          @click="contractsForRecalculationDownloadExcel"
        >
          {{ $t('CONTENT.reportPage.contracts_without_entries') }}
        </button>
        <div v-if="!showAllMessages">
          <div
            v-for="(message, index) in messages.slice(0, 5)"
            :key="index"
            class="b-notification__message"
          >
            {{ message }}
          </div>
        </div>
        <transition name="fade">
          <div v-if="showAllMessages">
            <div
              v-for="(message, index) in messages"
              :key="index"
              class="b-notification__message"
            >
              {{ message }}
            </div>
          </div>
        </transition>
        <div v-if="messages.length > 5">
          <button
            class="b-btn b-btn_type_empty px-0"
            @click="showAllMessages = !showAllMessages"
          >
            <div>{{ showAllMessages ? $t('CONTENT.hide') : `${$t('CONTENT.show_more')} ${messages.length - 5}` }}</div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import downloadFileMixin from '../../mixins/downloadFile';

export default {
  mixins: [downloadFileMixin],
  props: {
    discountRateNotifications: {
      type: Array,
      required: true,
    },
    fromHeaders: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showAllMessages: false,
      contractsWithoutDiscountRate: [],
    };
  },
  computed: {
    messages() {
      return this.buildDiscountRateNotificationsErrorMessage(this.discountRateNotifications, this.fromHeaders);
    },
    contractIds() {
      return this.buildContractIdsArray(this.discountRateNotifications, this.fromHeaders);
    },
  },
  methods: {
    buildDiscountRateNotificationsErrorMessage(discountRateNotifications, fromHeaders) {
      const mapNotification = (notification) => {
        const month = fromHeaders ? notification.Date : notification.date;
        const assetType = fromHeaders ? notification.AssetName : notification.assetName;
        const minCountMonthRent = fromHeaders ? notification.MinCountMonthRent : notification.minCountMonthRent;
        const maxCountMonthRent = fromHeaders ? notification.MaxCountMonthRent : notification.maxCountMonthRent;
        const minTotalPayment = fromHeaders ? notification.MinTotalPayment : notification.minTotalPayment;
        const maxTotalPayment = fromHeaders ? notification.MaxTotalPayment : notification.maxTotalPayment;
        const currency = fromHeaders ? notification.Currency : notification.currency;
        const errorMessage = minCountMonthRent !== maxCountMonthRent
          ? `${month}; ${assetType}, Срок аренды должен включать ${minCountMonthRent}-${maxCountMonthRent} мес., Сумма арендных платежей должна включать ${minTotalPayment}-${maxTotalPayment} ${currency}`
          : `${month}; ${assetType}, Срок аренды должен включать ${minCountMonthRent} мес., Сумма арендных платежей должна включать ${maxTotalPayment} ${currency}`;
        return errorMessage;
      };
      const notificationMessages = discountRateNotifications.map(mapNotification);
      return notificationMessages;
    },
    buildContractIdsArray(discountRateNotifications, fromHeaders) {
      const extractContractIds = notification => (fromHeaders ? (notification.ContractIds || []) : (notification.contractIds || []));
      return discountRateNotifications.flatMap(extractContractIds);
    },
    async contractsForRecalculationDownloadExcel() {
      this.contractsWithoutDiscountRate = this.contractIds;
      const originalType = this.importType;
      this.importType = 'editContractWithNewDiscountRate';
      await this.downloadTemplate();
      this.importType = originalType;
    },
  },
};
</script>

<style>
.b-notification-block {margin-top: 1rem;}

.b-notification {
  display: flex;
  align-items: center;
  border: 1px solid #FFC107;
  background-color: #FFFDE7;
}

.b-notification__icon-wrap {
  flex: 0 0 auto;
  color: #FFC107;
}

.b-notification__text-wrap {
  flex: 1 1 auto;
}

.b-notification__title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
}

.b-notification__message {
  margin-bottom: 4px;
}

.b-btn {
  text-decoration: underline;
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
